import { 
  uploadMapDataFile,
  getImportDataById,
  getImportDetails,
  deleteImportById
} from '../services/udapi/imports';
import noop from 'lodash-es/noop';


export default {
  namespace: 'importSidebar',
/*
  #TODO: Add better state management for success,
  failure, and neither import states.
  -- TJC - February 01, 2020
*/
  state: {
    acceptedFiles: [],
    acceptedFileConents: null,
    fileSizeError: false,
    importedFeatures: [],
    loading: false,
    lastSuccessfulUploadId: null,
    importError: null,
  },
  /*
    #TODO: Remove use of callback in the delete and submit
    effects
    -- TJC - February 10, 2020
  */
  effects: {
    *deleteLatestUpload({ callback = noop }, { call, select }) {
      const uploadId = yield select((model) => model.importSidebar.lastSuccessfulUploadId);
      if (!uploadId) {
        callback(null);
      }

      let delRes = yield call(deleteImportById, uploadId);

      if (delRes.success) {
        callback(delRes);
      } else {
        console.error('ERROR: Unable to delete upload', delRes);
        callback(null);
      }
    },
    *submitFile({ callback = noop }, { call, put, select }) {
      const fileContents = yield select((model) => model.importSidebar.acceptedFileContents);
      const response = yield call(uploadMapDataFile, fileContents);
      let uploadId = null;

      if (response.success && response.data.uploadId) {
        uploadId = response.data.uploadId;
          yield put({ type: 'setSuccessfulUploadId', payload: uploadId });
          callback(uploadId);
      } else {
        yield put({ type: 'setImportError', payload: response.data.message });
        callback();
      }
    },
    pollForImportDataEffect: [
      function*({ callback, payload: uploadId }, { call, put }) {
        const response = yield call(getImportDetails, uploadId);

        if (response.success) {
          // validation of file type
          if (response.data.valid === false) {
            yield put({ type: 'setImportError', payload: response.data.message });
            callback(null);
          } else if (response.data.completed) {
            // poll until completed is true, then get all features by their uploadId
            let importRes = yield call(getImportDataById, uploadId);
            
            if (importRes.success) {
              yield put({ type: 'setContentBuffer', payload: importRes.data });
            } else {
              yield put({ type: 'setImportError', payload: importRes.data.message });
            }
            callback(importRes.data.length);
          }
        } else {
          yield put({ type: 'setImportError', payload: response.data.message });
          callback(null);
        }
      },
      { type: 'poll', delay: 1000 }
    ]
  },
  reducers: {
    setSuccessfulUploadId(state, {payload: uploadId}) {
      return {
        ...state,
        lastSuccessfulUploadId: uploadId
      };
    },
    setImportError(state, {payload: error}) {
      return {
        ...state,
        importError: error
      };
    },
    setLoading(state, {payload: setTo}) {
      return {
        ...state,
        loading: setTo
      };
    },
    addFileContents(state, {payload: fileContents}) {
      return {
        ...state,
        acceptedFileContents: fileContents
      };
    },
    setContentBuffer(state, { payload: list }) {
      const importData = {
        collections: [],
        features: []
      }
      list.forEach(li => {
        if (li.type === 'collection') importData.collections.push(li)
        else importData.features.push(li)
      })
      return {
        ...state,
        importedCollections: importData.collections,
        importedFeatures: importData.features,
      };
    },
    updatedAcceptedFiles(state, { payload: files }) {
      return {
        ...state,
        acceptedFiles: files,
        fileSizeError: false,
      };
    },
    showFilesizeError(state, payload) {
      return {
        ...state,
        fileSizeError: true
      };
    },
    reset(state, payload) {
      return {
        ...state,
        acceptedFiles: [],
        fileSizeError: false,
        importError: null,
        loading: false,
        importedFeatures: [],
        acceptedFileConents: null,
        lastSuccessfulUploadId: null,
      };
    }
  }
};
